<template>
  <div>
    <b-skeleton-wrapper :loading="is_load">
      <template #loading>
        <div class="w-100 py-3 radius-6 mb-3 border-secondary-t" v-for="i in 2">
          <div class="row">
            <div class="col-10">
              <div class="pl-3">
                <b-skeleton width="30%" height="22px" class="mb-2"></b-skeleton>
                <b-skeleton width="100%" height="18px" class="mb-1"></b-skeleton>
                <b-skeleton width="70%" height="18px"></b-skeleton>
              </div>
            </div>
            <div class="col-2">
              <div class="pr-3">
                <b-skeleton width="100%" height="60px"></b-skeleton>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="w-100">
        <div class="py-4 text-center" v-if="error != ''">
          <ErrorMessage :message="error"></ErrorMessage>
        </div>
        <template v-else>
          <div class="w-100" v-if="not_selected">
            <p class="body-2 text-danger">Please select payment method</p>
          </div>
          <div class="w-100 p-3 radius-6 mb-3 cursor-pointer position-relative" v-for="(pm, index) in list" :class="pm.id == selected.id ? 'border-green' : 'border-form'">
            <div class="row no-gutters z-index-1026" @click="selectPayment(pm)">
              <div class="col-xl-1 col-2 align-self-center">
                <img :src="pm.image_url" class="w-100">
              </div>
              <div class="col-xl-10 col-9 align-self-center">
                <div class="px-3">
                  <p class="mb-0 text-ticket" :class="{
                    'body-1-4': window_width >= 576,
                    'body-2-4': window_width < 576
                  }">{{ pm.name }}</p>
                  <span v-if="pm.bank_name == 'DIRECT_PAYMENT' || (pm.bank_name == 'WISE' && pm.payment_method == 'BANK_TRANSFER')" class="body-3-3-2 mb-0 text-orange d-block">{{$t('general.manually-checked')}}</span>
                  <span v-else class="body-3-3-2 mb-0 text-green d-block">{{$t('general.checked-automatically')}}</span>
                  <p class="mb-0 html-desc" :class="{
                    'text-truncate-2': pm.id != selected.id,
                    'body-2-2-1': window_width >= 576,
                    'body-3-3-1': window_width < 576
                  }" v-html="pm.description"></p>
                </div>
              </div>
              <div class="col-xl-1 col-1 align-self-center text-center">
                <svg v-if="pm.id == selected.id" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_553_23)">
                    <path
                      d="M13 26C20.1118 26 26 20.0991 26 13C26 5.88824 20.0991 0 12.9873 0C5.88824 0 0 5.88824 0 13C0 20.0991 5.90099 26 13 26Z"
                      class="fill-primary" />
                    <path
                      d="M11.5725 19.2324C11.1392 19.2324 10.7824 19.0539 10.451 18.6079L7.25197 14.6824C7.0608 14.4275 6.94609 14.1471 6.94609 13.854C6.94609 13.2804 7.39217 12.8088 7.9657 12.8088C8.33531 12.8088 8.61571 12.9235 8.93432 13.3441L11.5216 16.6833L16.9638 7.94021C17.2059 7.55786 17.5373 7.35394 17.8687 7.35394C18.4294 7.35394 18.952 7.73629 18.952 8.33531C18.952 8.61571 18.7863 8.90885 18.6334 9.17649L12.6432 18.6079C12.3755 19.0285 12.0059 19.2324 11.5725 19.2324Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_553_23">
                      <rect width="26" height="26.0128" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <div class="primary-overlay z-index-1025" v-if="pm.id == selected.id"></div>
          </div>
        </template>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { get } from '@/services/index.js'

  export default {
    props:{
      module: {
        type: String,
        default: 'booking-engine'
      },
      sub_module: {
        type: String,
        default: ''
      },
      disabledForm:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        is_load: true,
        error: '',
        list: [],
        selected: {},
        not_selected: false,
        window_width: window.innerWidth
      }
    },  
    computed:{
      ...mapGetters(['getMerchant'])
    },
    mounted(){
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
      this.loadPaymentMethodList()
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResizeWindow); 
    },
    methods:{
      onResizeWindow(){
        this.window_width = window.innerWidth
      },
      selectPayment(data){
        if(!this.disabledForm){
          this.selected = data 
          this.$emit('selectPayment',data)
        }
      },
      loadPaymentMethodList(){
        return new Promise((success,fail)=>{
          this.is_load = true
          this.list = []
          this.not_selected = false
          let apiParams = { module: this.module }
          if(this.$isNotEmptyV2(this.sub_module)) apiParams.module_code = this.sub_module;
          const apiEndPoint = `merchant/${this.getMerchant.code}/payment-method`
          get("CORE_HOTEL", apiEndPoint, apiParams).then(response => {
            let res = response.data
            if (res.success) {
              this.list = res.data.map(payment => {
                const { channel, pg_company } = payment;
                payment.payment_method = channel
                payment.payment_channel = channel
                payment.bank_name = pg_company
                return payment;
              })
              success()
            } else {
              fail(res.message)
            }
            this.is_load = false
            setTimeout(()=>{
              this.$emit('doneLoad')
            },100)
          })
        })
      },
      validateForm(){
        return new Promise((success,fail)=>{
          if(this.selected.id) {
            this.not_selected = false
            success()
          }else{
            this.not_selected = true
            fail("PAYMENT")
          }
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/general/payment/PaymentMethod.vue